module.exports = __webpack_public_path__ + "img/down-service-arrow.7400b955.svg";